// Helper to derive the cookie domain based on language and runtime config
// This function is needed because the application serves multiple
// language-specific domains. Depending on the selected language (e.g., FR, IT),
// cookies must be set for the correct domain to ensure proper
// authentication/session sharing and compliance with browser security policies.
// For example, the default domain '.ihre-apotheke.ch' is replaced with
// '.votre-pharmacie.ch' for French and '.vostra-farmacia.ch' for Italian,
// so users remain logged in and sessions persist across the correct domain.
// We don't need to worry about local development, as here the cookie domain
// is not set and the browser will use the current domain automatically.
// The cookie domain for staging is the same as for production.
import { useRuntimeConfig } from '#app'
import type { Langcode } from '#graphql-operations'

export function deriveCookieDomain(langcode: Langcode): string {
  const {
    public: { cookieDomain },
  } = useRuntimeConfig()
  if (cookieDomain) {
    if (cookieDomain === '.ihre-apotheke.ch') {
      if (langcode === 'FR') {
        return '.votre-pharmacie.ch'
      } else if (langcode === 'IT') {
        return '.vostra-farmacia.ch'
      }
    }
  }
  return cookieDomain
}
